var React = require('react');

function CheckmarkInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M33.3231 9.25601C33.8427 9.71061 33.8953 10.5003 33.4407 11.0199L15.9407 31.0199C15.7129 31.2802 15.3874 31.4345 15.0416 31.446C14.6958 31.4576 14.3607 31.3252 14.1161 31.0806L6.61612 23.5806C6.12796 23.0925 6.12796 22.301 6.61612 21.8128C7.10427 21.3247 7.89573 21.3247 8.38388 21.8128L14.9391 28.3681L31.5593 9.3736C32.0139 8.85406 32.8036 8.80141 33.3231 9.25601Z","fill":"#00C05B"}));
}

CheckmarkInline.defaultProps = {"width":"40","height":"41","viewBox":"0 0 40 41","fill":"none"};

module.exports = CheckmarkInline;

CheckmarkInline.default = CheckmarkInline;
